import DeleteIcon from "@mui/icons-material/Delete";
import { Button, IconButton, Tooltip, Typography } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { addLocalContratista, deleteLocalContratista } from "../../../../redux/actions/rgrl";
import { tableConfig } from "../../../commons/table/tableConfig";
import { StyledRgrl } from "../../../styled/Prevencion";
import AddContratistaDialog from "./dialog/AddContratistaDialog";

const ContratistasTable = ({ data, handleSubmit }) => {
  const dispatch = useDispatch();
  const [openAddContratista, setOpenAddContratista] = useState(false);

  const columns = useMemo(() => [
    {
      accessorKey: "cuit",
      header: "CUIT",
      size: 200,
    },
    {
      accessorKey: "contratista",
      header: "Contratista / Observaciones",
      Cell: ({ row }) => row.original.contratista ? row.original.contratista : row.original.detalle ? row.original.detalle : "",
    },
  ], []);

  const deleteContratista = (values) => {
    dispatch(deleteLocalContratista(values.cuit));
  };

  const handleClose = () => {
    setOpenAddContratista(false);
  };

  const addContratista = () => {
    setOpenAddContratista(true);
  };

  const handleSubmitDialog = (values) => {
    dispatch(addLocalContratista(values));
    setOpenAddContratista(false);
  };

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: data || [],
    enableRowActions: true,
    positionActionsColumn: "last",
    displayColumnDefOptions: {
      ...tableConfig.displayColumnDefOptions,
      'mrt-row-actions': {
        header: 'Acciones',
        size: 80, // Narrower column
        muiTableHeadCellProps: {
          align: 'center',
          sx: {
            ...tableConfig.muiTableHeadCellProps.sx,
            justifyContent: "center"
          }
        },
        muiTableBodyCellProps: {
          align: 'center', // Center content in body cells
          sx: {
            padding: '4px' // Smaller padding
          }
        }
      },
    },
    renderRowActions: ({ row }) => (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Tooltip title="Eliminar" placement="bottom">
          <IconButton
            size="small"
            onClick={() => deleteContratista(row.original)}
            color="info"
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    ),
    renderEmptyRowsFallback: () => (
      <StyledRgrl.MessageContainer>
        <Typography>No hay contratistas agregados</Typography>
      </StyledRgrl.MessageContainer>
    ),
    renderBottomToolbarCustomActions: () => (
      <StyledRgrl.TableButtonContainer>
        <Button
          color="primary"
          onClick={addContratista}
        >
          Agregar
        </Button>
      </StyledRgrl.TableButtonContainer>
    ),
    enablePagination: true,
    paginationDisplayMode: 'pages',
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 25],
      labelRowsPerPage: "Filas por página:",
      getItemAriaLabel: (type) => {
        if (type === 'first') return 'ir a la primera página';
        if (type === 'last') return 'ir a la última página';
        if (type === 'next') return 'ir a la página siguiente';
        return 'ir a la página anterior';
      },
      labelDisplayedRows: ({ from, to, count }) =>
        `${from}-${to} de ${count !== -1 ? count : to}`,
    },
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
      density: 'compact',
    },
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enableColumnActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    localization: {
      ...MRT_Localization_ES,
      noRecordsToDisplay: "No hay contratistas agregados",
    },
  });

  return (
    <>
      <StyledRgrl.TableContainer>
        <MaterialReactTable table={table} />
      </StyledRgrl.TableContainer>
      <AddContratistaDialog
        open={openAddContratista}
        handleClose={handleClose}
        handleSubmit={handleSubmitDialog}
      />
    </>
  );
}

export default ContratistasTable;